export const theme = process.env.REACT_APP_THEME
export const isUniversity = theme === 'university'
